import { Component, Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

const statsModuleFields = [
  {
    name: 'stats',
    type: 'list',
    helperText: 'Add statistics to display. Recommended: 3 items for optimal layout.',
    defaultValue: [
      {
        value: '10x',
        description: 'Faster integration delivery',
      },
      {
        value: '95%',
        description: 'Reduction in development time',
      },
      {
        value: '5x',
        description: 'ARPU increase',
      },
    ],
    subFields: [
      {
        name: 'value',
        type: 'string',
        helperText: 'The main statistic value (e.g., "10x", "95%", "5x")',
        required: true,
        defaultValue: '10x',
      },
      {
        name: 'description',
        type: 'string',
        helperText: 'Description text that appears below the statistic',
        required: true,
        defaultValue: 'Faster integration delivery',
      },
    ],
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const statsModuleConfig = {
  name: 'StatsModule',
  inputs: statsModuleFields,
} as Component;

export interface Stat {
  value: string;
  description: string;
}

export interface StatsModuleConfigProps extends GenerateBuilder<typeof statsModuleFields> {
  stats?: Stat[];
}

export default statsModuleConfig;
